export function getCssVar(name: string) {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
}
